import { render, staticRenderFns } from "./primary-button.vue?vue&type=template&id=9eea1b9a&scoped=true"
import script from "./primary-button.vue?vue&type=script&lang=js"
export * from "./primary-button.vue?vue&type=script&lang=js"
import style0 from "./primary-button.vue?vue&type=style&index=0&id=9eea1b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eea1b9a",
  null
  
)

export default component.exports